import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Location from "../../components/location/Location";
import LocationPhone from "../../components/location/LocationPhone";
import "./List.scss";
import { useParams } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { NotificationManager } from "react-notifications";
import { Tag } from "../../utils/GTMPageTag";


import {
  getHomeLocationCountries,
  getHomePhoneArea,
  getPageContent,
  getMailProductCitiesByCountry,
} from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";

const LocationsList = (props) => {
  Tag("LocationsList")
  const { product, country } = useParams();

  
  const [selectTab, setSelectedTab] = useState(product ?? "mailbox");
  useEffect(()=>{
    if(country === undefined){
      window.history.replaceState({}, null, props.link+'/'+selectTab);
    }

    switch(selectTab){
      case 'phonenumber':
        getAllCountries(2);
        break;      
      case 'mailbox':
      default:
        getAllCountries(1);
        break;      
    }
  }, [selectTab]);

  const [countries, setCountries] = useState([]);
  const getAllCountries = async (product_id) => {
    try {
      let apiRes = await getHomeLocationCountries(product_id);
      let responseData = await apiRes.json();

      if (responseData.res) {
        let sortedCountries = [];

        const dataArr = Object.values(responseData.data).flat();
        switch(selectTab){
          case 'phonenumber':
            sortedCountries = dataArr.sort((a, b) =>
              a.name.localeCompare(b.name)
            );
            break;
          case 'mailbox':
          default:
            sortedCountries = dataArr.sort((a, b) =>
              a.country_name.localeCompare(b.country_name)
            );
            break;
        }
        setCountries(sortedCountries);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    if(countries.length>0){
      let countryNotFound = undefined;
      switch(selectTab){
        case 'phonenumber':
          countryNotFound = countries.find(e => e.id === selectedPhoneTab);
          break;
        case 'mailbox':
        default:
          countryNotFound = countries.find(e => e.country.id === selectedCountryTab);
          break;
      }

      if(countryNotFound === undefined){
        switch(selectTab){
          case 'phonenumber':
            if(selectedPhoneTab === null){
              setSelectedPhoneTab(countries[0].id)
              window.history.replaceState({}, null, props.link+'/'+selectTab+'/'+selectedPhoneTab);
            }
            break;
          case 'mailbox':
          default:
            if(selectedPhoneTab === null){
              setSelectedCountryTab(countries[0].country.id)
              window.history.replaceState({}, null, props.link+'/'+selectTab+'/'+selectedCountryTab);
            }
            break;
        }
      }
    }
  },[countries])
  
  const [mailBoxData, setMailBoxData] = useState([]);
  const [phoneAreaData, setPhoneAreaData] = useState([]);
  const getCountryCities = async (country_id) => {
    try {
      let apiRes = await getMailProductCitiesByCountry(
        country_id,
        hostLanguage
      );
      let responseData = await apiRes.json();
      if (responseData.res) {
        const dataArr = Object.values(responseData.data).filter(
          (obj) => typeof obj === "object"
        );
        setMailBoxData(dataArr);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getPhoneArea = async (product_id, country_id) => {
    try {
      let apiRes = await getHomePhoneArea(product_id, country_id, hostLanguage);
      let responseData = await apiRes.json();
      
      if (responseData.res) {
        setPhoneAreaData(responseData.data);
      } else {
        NotificationManager.error('getPhoneArea' + responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [selectedCountryTab, setSelectedCountryTab] = useState(country ?? null);
  const [selectedPhoneTab, setSelectedPhoneTab] = useState(country ?? null);
  useEffect(()=> {
    console.log("SET", selectedCountryTab);
    if(selectedCountryTab !== null && selectTab === "mailbox"){
      if(!isNaN(selectedCountryTab)){
        window.history.replaceState({}, null, props.link+'/'+selectTab+'/'+selectedCountryTab);
      }
      setMailBoxData([]);
      getCountryCities(selectedCountryTab);
    }
  },[selectedCountryTab]);

  useEffect(()=> {
    console.log("SETPHONE", selectedPhoneTab);
    if(selectedPhoneTab !== null && selectTab === "phonenumber"){
      if(!isNaN(selectedPhoneTab)){
        window.history.replaceState({}, null, props.link+'/'+selectTab+'/'+selectedPhoneTab);
      }
      setPhoneAreaData([]);
      getPhoneArea(2, selectedPhoneTab);
    }
  },[selectedPhoneTab]);

  const { hostLanguage } = useLangContext();
  const [ contentDetails, setContentDetails ] = useState();
  const getAllPageContent = async () => {
    try {
      let apiRes = await getPageContent(hostLanguage, "locations_page_data");
      let responseData = await apiRes.json();
      if (responseData.res) {
        setContentDetails(responseData.data);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllPageContent();
  }, [hostLanguage]);
  return (
    <div className="MainbBody LocationsWithoutMap">
      <div className="PricelistBanner MapBanner">
        <Container>
          <Row>
            <Col sm={8}>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    contentDetails?.locations_page_data
                      ?.banner_text,
                }}
              ></div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PricelistBody">
        <Container>
          <Row>
            <Col sm={12}>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    contentDetails?.locations_page_data
                      ?.page_heading,
                }}
              ></div>
            </Col>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  contentDetails?.locations_page_data
                    ?.description_1,
              }}
            ></div>
          </Row>
          <Row className="PricelistTab">
            <Col sm={12}>
              <Tabs
                id="productTabSelection"
                className="mb-3"
                defaultActiveKey={selectTab}
                onSelect={(e) => {setCountries([]); setSelectedTab(e)}}
              >
                <Tab
                  key={0}
                  eventKey="mailbox"
                  title={contentDetails?.locations_page_data?.tab_1_text ?? "TAB"}
                >
                  <div className="DigitalmailboxinLftCheckBox DigitalmailboxinLftCheckBox5">
                    {countries.length > 0 && selectTab === "mailbox" ?
                      <Tabs
                        id="mailboxCountryTabSelection"
                        className="mb-3"
                        
                        activeKey={selectedCountryTab}
                        onSelect={(e) => {setSelectedCountryTab(e)}}
                      >
                        {countries?.map((item, index) => {
                          return (
                              <Tab
                                key={item.country.id}
                                eventKey={item.country.id}
                                title={item.country.name}
                              >
                                <div className="BoxDesign">
                                  {mailBoxData?.map((item, index) => {
                                    let position = null;
                                    if (
                                      item?.city?.lat != null &&
                                      item?.city?.lon != null
                                    ) {
                                      position = [
                                        item?.city?.lat,
                                        item?.city?.lon,
                                      ];
                                    }

                                    return (
                                      <Location
                                        key={index}
                                        item={item?.city}
                                        position={position}
                                      />
                                    );
                                  })}
                                </div>
                              </Tab>
                            )
                        })}
                      </Tabs>
                    :
                      <></>
                    }
                  </div>
                </Tab>
                <Tab
                  key={1}
                  eventKey="phonenumber"
                  title={contentDetails?.locations_page_data?.tab_2_text ?? "TAB"}
                >
                  <div className="DigitalmailboxinLftCheckBox DigitalmailboxinLftCheckBox5">
                    {countries.length > 0 && selectTab === "phonenumber" ?
                      <Tabs
                        id="phonenumberCountryTabSelection"
                        className="mb-3"
                        activeKey={selectedPhoneTab}
                        onSelect={(e) => {setSelectedPhoneTab(parseInt(e))}}
                      >
                        {countries?.map((item, index) => {
                          return (
                              <Tab
                                key={item.id}
                                eventKey={item.id}
                                title={item.name}
                              >
                                <div className="BoxDesign">
                                  {phoneAreaData?.map((item, index) => {
                                    return (
                                      <LocationPhone
                                        key={index}
                                        id={item?.id}
                                        country={item?.country_id}
                                        text={item?.area_text}
                                        price={item?.monthly_fee}
                                      />
                                    );
                                  })}
                                </div>
                              </Tab>
                            )
                        })}
                      </Tabs>
                    :
                      <></>
                    }
                  </div>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
};

export default LocationsList;
